<template>
  <div v-title="$route.meta.title">
    <div class="page-heading">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item to="/">首页</el-breadcrumb-item>
        <el-breadcrumb-item>平台管理</el-breadcrumb-item>
        <el-breadcrumb-item>{{$route.meta.title}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <layout-panel>
      <template slot="header">列表</template>
      <template slot="tools">
        <el-button type="primary"
                   size="small"
                   icon="el-icon-refresh"
                   @click="onRefresh()"></el-button>
      </template>

      <el-table :data="table"
                stripe
                highlight-current-row
                border
                style="width: 100%">
        <el-table-column prop="id"
                         label="ID"
                         min-width="50"></el-table-column>
        <el-table-column prop="display_name"
                         label="名称"
                         min-width="120">
          <template slot-scope="scope">
            <span style="cursor:pointer;color:rgb(88,157,248)"
                  @click="onDownSourceFile(scope.row.id)">{{scope.row.display_name}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="admin_name"
                         label="发起者"
                         min-width="120"></el-table-column>
        <el-table-column prop="created_at"
                         label="上传时间"
                         min-width="140"></el-table-column>
        <el-table-column label="任务进度"
                         min-width="120">
          <template slot-scope="scope">
            <sj-progress :text-inside="true"
                         :stroke-width="18"
                         :status="taskBatchStatus(scope.row)"
                         :percentages="taskBatchPercentage(scope.row)"></sj-progress>
            成功:{{scope.row.success_count}} 错误:{{scope.row.error_count}}
          </template>
        </el-table-column>
        <el-table-column prop="task_type"
                         label="类型"
                         min-width="120">
          <template slot-scope="scope">
            <span v-for="item in options.task_type"
                  v-if="scope.row.task_type === item.value">{{item.label}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="status"
                         label="状态"
                         min-width="120">
          <template slot-scope="scope">
            <span v-for="item in status"
                  v-if="scope.row.status === item.value">{{item.label}} {{scope.row.status === -2 ? `(${scope.row.error_message})` : ''}}</span>
          </template>
        </el-table-column>
        <el-table-column fixed="right"
                         label="操作"
                         width="260">
          <template slot-scope="scope">
            <span v-if="(scope.row.status === 3 && scope.row.error_count > 0)">
              <el-button type="text"
                         size="mini"
                         @click="onDownErrorFile(scope.row.id)">下载错误行</el-button>
            </span>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination background
                       @size-change="handleSizePageChange"
                       @current-change="handleCurrentPageChange"
                       :current-page="pagination.current_page"
                       :page-sizes="[20, 50, 100, 200]"
                       :page-size="pagination.per_page"
                       layout="total, sizes, prev, pager, next, jumper"
                       :total="pagination.total">
        </el-pagination>
      </div>
    </layout-panel>
  </div>
</template>

<script>
import table from '@core/mixins/table'
import downloadJS from '@/vendor/download'
import { getToken } from '@utils/auth'
import SjProgress from '@/components/sj-progress'
import taskBatchMixins from '@/views/task-batch/task-batch.mixins'

export default {
  mixins: [table, taskBatchMixins],
  components: {SjProgress},
  data () {
    return {
      options: {
        task_type: [
          {value: 1, label: '创建外呼任务'},
          {value: 2, label: '增加外呼明细'},
          {value: 3, label: '更新外呼明细'},
        ],
      },
      search: {
        collection_type: 1,
        number: this.$route.params.number || '',
      },
    }
  },
  computed: Vuex.mapState({
    status: state => state.taskBatch.status,
  }),
  created () {},
  methods: {
    ...Vuex.mapActions([]),
    /**
     * 获得表格数据
     * @param {*} params
     */
    getTableData (params) {
      return request.common('robotCallqueryBatchUpload', params)
    },
    onDownSourceFile (id) {
      downloadJS(request.items.robotCalldownSourceFile(id), false, false, {
        'SJ-Auth-Token': getToken()
      })
    },
    onDownErrorFile (id) {
      downloadJS(request.items.robotCalldownErrorFile(id), false, false, {
        'SJ-Auth-Token': getToken()
      })
    },
    onUnprocessFile (id) {
      downloadJS(request.items.downUnprocessFile(id))
    },
    onUploadFile (file, type) {
      let isLt10M = file.raw.size / 1024 / 1024 < 5
      if (!isLt10M) {
        this.$message.error('大小不能超过10MB!')
        this.$refs.upload.clearFiles()
        return false
      }

      let formData = new FormData()
      formData.append('file', file.raw)
      if (type === 1) {
        this.batchUploadAddRole(formData)
      } else if (type === 2) {
        this.batchUploadDelRole(formData)
      } else if (type === 3) {
        this.batchUploadUpdateEmail(formData)
      } else {
        return false
      }
    },

    batchUploadAddRole (formData) {
      request.common('batchUploadAddRole', formData).then(({data}) => {
        this.$message({
          showClose: true,
          message: '上传成功',
          type: 'success',
        })
        this.onSearch()
      })
    },
    batchUploadDelRole (formData) {
      request.common('batchUploadDelRole', formData).then(({data}) => {
        this.$message({
          showClose: true,
          message: '上传成功',
          type: 'success',
        })
        this.onSearch()
      })
    },
    batchUploadUpdateEmail (formData) {
      request.common('batchUploadUpdateEmail', formData).then(({data}) => {
        this.$message({
          showClose: true,
          message: '上传成功',
          type: 'success',
        })
        this.onSearch()
      })
    },
  },
}
</script>
<style lang="scss">
// 全局CSS
</style>
<style lang="scss"
       scoped>
// 带作用域的CSS
// https://vue-loader.vuejs.org/zh-cn/features/scoped-css.html
</style>
<style lang="scss"
       module>
// 带作用域的CSS
// 绑定class方式 <p :class="$style.red"></p>
// https://vue-loader.vuejs.org/zh-cn/features/css-modules.html
</style>



// WEBPACK FOOTER //
// src/views/intelligent-outbound-call/pages/IntelligentOutboundCallUploadTable.vue